var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "feature-card" }, on: { click: _vm.gotoPlans } },
    [
      !_vm.currentPlan
        ? _c(
            "div",
            { staticClass: "water-mark" },
            [
              _c("SupsisButton", { attrs: { primary: true } }, [
                _vm._v(" " + _vm._s(_vm.$t("billing.buyNow"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "feature-logo" },
        [
          _vm.plan.dynamicType === "team-integration"
            ? _c("TeamIntegration")
            : _vm._e(),
          _vm._v(" "),
          _vm.plan.dynamicType === "ticket-system"
            ? _c("TicketSystem")
            : _vm._e(),
          _vm._v(" "),
          _vm.plan.dynamicType === "telegram"
            ? _c("TelegramEntegration")
            : _vm._e(),
          _vm._v(" "),
          _vm.plan.dynamicType === "ai-assistant"
            ? _c("AIAssistant")
            : _vm._e(),
          _vm._v(" "),
          _vm.plan.dynamicType === "visitor-chat-start"
            ? _c("VisitorChatStart")
            : _vm._e(),
          _vm._v(" "),
          _vm.plan.dynamicType === "webhook-integration"
            ? _c("WebhookIntegration")
            : _vm._e(),
          _vm._v(" "),
          _vm.plan.dynamicType === "task-management"
            ? _c("TaskManagment")
            : _vm._e(),
          _vm._v(" "),
          _vm.plan.dynamicType === "mail-entegration"
            ? _c("MailEntegration")
            : _vm._e(),
          _vm._v(" "),
          _vm.plan.dynamicType === "software-support"
            ? _c("SoftwareSupport")
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "feature-content" }, [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.plan.altTitle) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _vm.currentPlan
            ? _c("div", [
                _vm.detailPackage().renewed
                  ? _c("div", [
                      _c("b", [_vm._v("Yenilenme Tarihi:")]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.detailPackage().endDate))]),
                    ])
                  : _c("div", [
                      _c("b", [_vm._v("Kalan Süre:")]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(_vm.detailPackage().leftTime) + " gün"),
                      ]),
                    ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }